import React from 'react'
import OemHero from './OemHero'
import OemLenders from './OemLenders'
import OemRequestInfo from './OemRequestInfo'

const OemIndex = () => {
  return (
    <React.Fragment>
        <OemHero />
        <OemLenders />
        <OemRequestInfo />
    </React.Fragment>
  )
}

export default OemIndex